<template>
  <el-row>

    <link href="//static.ucsc.edu/css/directory-page.css" media="all" rel="stylesheet" type="text/css">

    <h1 class="page-title" id="title"><span class="p-name">{{[].concat(teacher.cn)[0]}}</span></h1>
    <div class="section-container person list-page" id="teacher-info">
      <div class="section-body">
        <div class="section-item h-card wrap">
          <div class="item-image square-img imgLiquid">
            <img v-if="teacher.jpegphoto" :src="teacher.jpegphoto" :alt="[].concat(teacher.cn)[0]"/>
            <img v-else src="//static.ucsc.edu/images/icon-slug.jpg" :alt="[].concat(teacher.cn)[0]">
          </div>
          <div class="item-body">
            <ul class="item-info">
              <li v-if="teacher.title"><strong>Title</strong> 
                <ul class="inline-list">
                  <li v-for="item in [].concat(teacher.title)">{{item}}</li>
                </ul>
              </li>
               <li v-if="teacher.ucscpersonpubdivision">
                <strong>Division</strong> 
                <template v-for="item, key in [].concat(teacher.ucscpersonpubdivision)">
                  <template v-if="key > 0">; </template>{{item}}</template>
              </li>
              <li v-if="teacher.ucscpersonpubdepartmentnumber"><strong>Department</strong> 
                <ul class="inline-list">
                  <li v-for="item in [].concat(teacher.ucscpersonpubdepartmentnumber)">{{item}}</li>
                </ul>
              </li>
              <li v-if="teacher.ucscpersonpubaffiliateddepartment">
                <strong>Affiliations</strong> 
                <template v-for="item, key in [].concat(teacher.ucscpersonpubaffiliateddepartment)">
                  <template v-if="key > 0">, </template>{{item}}</template>
              </li>
              <li v-if="teacher.telephonenumber"><strong>Phone</strong> 
                <div>
                  <span style="white-space: nowrap" class="p-tel">
                    <template v-for="item, key in [].concat(teacher.telephonenumber)">
                      <template v-if="key > 0">, </template>
                      {{item}}
                    </template>
                  </span>
                </div>
              </li>
              <li v-if="teacher.mail || teacher.ucscpersonpubalternatemail"><strong>Email</strong> 
                <ul class="inline-list">
                  <li v-for="item in [].concat(teacher.mail)">
                    <span class="u-email">
                      <a :href="`mailto:${item}`">{{item}}</a>
                    </span>
                  </li>
                  <template v-for="item in [].concat(teacher.ucscpersonpubalternatemail)">
                    <li v-if="![].concat(teacher.mail).includes(item)">
                      <span class="u-email">
                        <a :href="`mailto:${item}`">{{item}}</a>
                      </span>
                    </li>
                  </template> 
                 </ul>
              </li>
              <li v-if="teacher.facsimiletelephonenumber"><strong>Fax</strong> 
                <ul class="inline-list">
                  <li v-for="item in [].concat(teacher.facsimiletelephonenumber)">
                      <span style="white-space: nowrap" class="p-tel">{{item}}</span>
                  </li>
                </ul>
              </li>
              <li v-if="teacher.ucscpersonpubwebsite"><strong>Website</strong>
                <ul class="inline-list" >
                  <li v-for="item in [].concat(teacher.ucscpersonpubwebsite)">
                    <span class="u-url">
                      <a :href="item.substr(0,item.indexOf(' '))" target="_website">
                        {{item.substr(item.indexOf(' ')+1)}}
                      </a>
                    </span>
                  </li>
                </ul>
              </li>
               <li v-if="teacher.ucscprimarylocationpubofficialname"><strong>Office Location</strong> 
                <ul class="inline-list">
                  <li>
                    <span class="p-extended-address">
                      {{[].concat(teacher.ucscprimarylocationpubofficialname)[0]}}, {{[].concat(teacher.ucscpersonpubofficelocationdetail)[0]}} 
                    </span>
                  </li>
                  <li v-if="teacher.roomnumber">
                    <span class="p-extended-address">{{[].concat(teacher.roomnumber)[0]}} </span>
                  </li>
                </ul>
              </li>
              <li v-if="teacher.ucscpersonpubofficehours"><strong>Office Hours</strong> 
                <ul class="inline-list">
                  <li v-for="item in [].concat(teacher.ucscpersonpubofficehours)">{{item}}</li>
                </ul>
              </li>
              <li v-if="teacher.ucscpersonpubmailstop"><strong>Mail Stop</strong> 
                {{[].concat(teacher.ucscpersonpubmailstop)[0]}}
              </li>
              <li v-if="teacher.street"><strong>Mailing Address</strong> 
                <ul class="inline-list">
                  <li>{{[].concat(teacher.street)[0]}}</li>
                  <li>Santa Cruz CA 95064 </li> 
                </ul>
              </li>
              <li v-if="teacher.ucscpersonpubexpertisereference"><strong>Faculty Areas of Expertise</strong> 
                <span class="p-label">
                  <template v-for="item, key in [].concat(teacher.ucscpersonpubexpertisereference)">
                    <template v-if="key > 0">, </template>{{item}}</template>
                </span>
              </li>
              <li v-if="teacher.ucscpersonpubfacultycourses">
                <strong>Courses Taught</strong> 
                <template v-for="item, key in [].concat(teacher.ucscpersonpubfacultycourses)">
                  <template v-if="key > 0">; </template>{{item}}</template>
              </li>
            </ul>
          </div> <!-- item-body -->
        </div> <!-- section-item -->
        <div class="section-item">
          <div class="item-body expertise">
            <div v-if="teacher.ucscpersonpubareaofexpertise" class="item-expertise">
              <h3>Summary of Expertise</h3>
              <div v-for="item in [].concat(teacher.ucscpersonpubareaofexpertise)" class="item-expertise" v-html="item"></div>
            </div>
            <div v-if="teacher.ucscpersonpubresearchinterest" class="item-expertise">
              <h3>Research Interests</h3>
              <div  v-for="item in [].concat(teacher.ucscpersonpubresearchinterest)" class="item-expertise" v-html="item"></div>
            </div>
            <div v-if="teacher.ucscpersonpubdescription" class="item-expertise">
              <h3>Biography, Education and Training</h3>
              <div  v-for="item in [].concat(teacher.ucscpersonpubdescription)" class="item-expertise" v-html="item"></div>
            </div>
            <div v-if="teacher.ucscpersonpubawardshonorsgrants" class="item-expertise">
              <h3>Honors, Awards and Grants</h3>
              <div  v-for="item in [].concat(teacher.ucscpersonpubawardshonorsgrants)" class="item-expertise" v-html="item"></div>
            </div>
            <div v-if="teacher.ucscpersonpubselectedpublication" class="item-expertise">
              <h3>Selected Publications</h3>
              <div v-for="item in [].concat(teacher.ucscpersonpubselectedpublication)" class="item-expertise" v-html="item"></div>
            </div>
            <div v-if="teacher.ucscpersonpubselectedpresentation" class="item-expertise">
              <h3>Selected Presentations</h3>
              <div  v-for="item in [].concat(teacher.ucscpersonpubselectedpresentation)" class="item-expertise" v-html="item"></div>
            </div>
            <div v-if="teacher.ucscpersonpubteachinginterest" class="item-expertise">
              <h3>Teaching Interests</h3>
              <div  v-for="item in [].concat(teacher.ucscpersonpubteachinginterest)" class="item-expertise" v-html="item"></div>
            </div>
          </div> <!-- ./item-body -->
        </div>
        <!-- ./section-item -->
      </div> <!-- section-body -->
    </div> <!-- section-container -->             

    <!-- <code>{{ teacher }}</code> -->
  </el-row>
</template>

<script>
import axios from 'axios'

export default {
  layout: 'basic',

  metaInfo () {
    return { title: [].concat(this.teacher.cn)[0], titleTemplate: null }
  },

  data: () => ({
    title: 'testing',
    uid: '',
    teacher: {},
    loading: true
  }),

  created () {
    this.uid = this.$route.params.uid

    if (this.uid) {
      this.getTeacher(this.uid)
    }
  },

  methods: {
    async getTeacher (uid) {
      try {
        // this.loading = true
        const { data } = await axios.get('https://campusdirectory.ucsc.edu/api/uid/'+uid)
        this.teacher = data
        this.loading = false
      } catch (e) {
        console.log('Error: uid lookup')
        this.$alert('The Campus Directory is currently offline.', 'Offline', {
          confirmButtonText: 'Dismiss'
        })
      }
    }
  }
}
</script>

<style lang="scss">

  @media print {
    html, body{
      width: 8.5in !important;
      height: 11in !important;
    }

    @page {
      size: 8.5in 11in;
      margin-top: 0.35in;
      margin-left: 0.5in;
      margin-right: 0.5in;
      margin-bottom: 0.35in;
    } 

    #teacher-info .item-info  > li {
      align-items: flex-start;
      flex-direction: row;
      -webkit-flex-direction: row;
    }
    #teacher-info .item-info > li {
      border-bottom: 0;
    }
    #teacher-info .item-info li strong {
      flex: 0 0 180px;
      text-align: right;
      padding-right: 1.5em;
    }
    #teacher-info .item-info  li span {
      flex: 0 1 auto;
    }
    div.contentBox, div.breadcrumbs, .site-header, .sidebar, .main-footer {
      display: none;
    }
    #teacher-info .item-expertise {
      page-break-inside: auto;
      break-inside: auto;
    }
    #wrap, #container, #content , #sprflt, #main { border: none !important; } 
  }

</style>



// WEBPACK FOOTER //
// resources/js/pages/teacher.vue